/* eslint-disable @typescript-eslint/no-explicit-any */
// config/org.config.ts
import {services as bometServices} from './icrms/services';

export const baringoConfig = {
  name: 'BaringoPay - Customer Portal',
  themeMode: 'light', // default: "light" | can toggle dynamically
  theme: {
    light: {
      primary: '#5EBD3E',
      secondary: '#5EBD3E',
      accent: '#BD3E5F',
      background: '#ffffff',
      foreground: '#171717',
      'surface-header': '#FFFCEE',
    },
    dark: {
      primary: '#006300',
      secondary: 'rgba(44, 149, 191, 1)',
      accent: 'rgba(191, 44, 71, 1)',
      background: '#0a0a0a',
      foreground: '#ededed',
      'surface-header': '#FFFCEE',
    },
  },

  // Assets (served from /dev/baringo/public)
  logo: `/baringo/logo.svg`,
  favicon: '/baringo/favicon-64.png',
  faviconSvg: '/baringo/favicon.svg',
  favicon64: '/baringo/favicon-64.png',
  favicon128: '/baringo/favicon-128.png',

  // Hero section
  heroSection: {
    title: (
      <>
        BaringoPay –{' '}
        <span className="text-[var(--color-accent)]">fast & secure</span> county
        payments
      </>
    ),
    description:
      'Experience hassle-free payments for county services with just a few clicks in Baringo County.',
    image: `/baringo/images/herosection.png`,
  },

  // Services section
  servicesSection: {
    title: 'BaringoPay Services',
    description:
      'BaringoPay enables you to access and make payments for a wide range of services from the County Government of Baringo.',
    services: bometServices, // 👈 loaded from config/bomet/services.ts
  },

  contact: {
    hq: {
      coords: [0.4919, 35.7436], // Example: Kabarnet town coords
      label: 'Baringo County Headquarters – Kabarnet',
    },
    details: [
      {
        id: 'postal',
        label: 'Postal Address',
        value: (
          <>
            P.O. Box 53–30400
            <br />
            Kabarnet, Baringo County
          </>
        ),
      },
      {
        id: 'email',
        label: 'Email',
        value: <>info@baringo.go.ke</>,
      },
      {
        id: 'tel',
        label: 'Telephone',
        value: <>053-22077</>,
      },
      {
        id: 'support',
        label: 'Toll-Free Line',
        value: <>1554</>,
      },
    ],
  },
  // Footer section
  footer: {
    description:
      'The Baringo County Service Portal provides easy access to a wide range of services, from business licenses to essential services. Pay securely and manage all your county-related tasks from one platform.',
    copyright: '© 2025 County Government of Baringo. All rights reserved.',
    links: [
      { title: 'Home', url: '#' },
      { title: 'Services', url: '#' },
      { title: 'Contact Us', url: '#' },
      { title: 'User Account', url: '#' },
      { title: 'Support', url: '#' },
      { title: 'Legal', url: '#' },
    ],
  },

  // API base URL
  getApiBaseUrl: () => {
    if (typeof window !== 'undefined') {
      return (window as any).__RUNTIME_CONFIG__?.NEXT_PUBLIC_BASE_API;
    }
    return process.env.NEXT_PUBLIC_BASE_API;
  },
};
